import React from 'react';
import { routesConfig } from '@src/core/routes';
import { Navigate, Route, Routes } from 'react-router-dom';
import { ArcGlobalLoading } from '@src/core/widgets';
import { FlightProvider } from '@src/features/order/provider';

const OrderFeature = React.lazy(() => import('@src/features/order'));
const ProfileFeature = React.lazy(() => import('@src/features/profile'));
const ViewerFeature = React.lazy(() => import('@src/features/viewer'));

const ViewerRoutes: React.FC = () => {
  return (
    <FlightProvider>
      <React.Suspense fallback={<ArcGlobalLoading />}>
        <Routes>
          <Route path='/profile/*' element={<ProfileFeature />} />
          <Route path='/viewer/*' element={<ViewerFeature />} />
          <Route path='/orders/*' element={<OrderFeature />}/>
          <Route path='*' element={<Navigate to={routesConfig.viewer}/>} />
        </Routes>
      </React.Suspense>
    </FlightProvider>
  );
};

export default ViewerRoutes;
